<template>
  <div class="carousel_wrap">
    <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1 style="font-size: 2.8rem">{{ item.line1 }}</h1>
          <h1 class="font-style2" >{{ item.line2 }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1 style="font-size: 2.8rem; align-items: center ">{{ item.line1 }}</h1>
          <h1 class="font-style2" >{{ item.line2 }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          src: require('@/assets/img/banner1.png'),
          line1: '文汇昌与你同行，成就求学未来',
          line2: '从求学到生活，为您和家庭打造完美的升学体验！',
        },
        {
          src: require('@/assets/img/banner2.png'),
          line1: '逆袭名校，从这里开始',
          line2: '职业教育为你提供另一条通往名校的道路，无需复读，弯道超车.',
        },
        {
          src: require('@/assets/img/banner3.png'),
          line1: '国内名校 ，全日制学历，升学轻松读！',
          line2: '职业高考之路，遇见更好的未来！',
        },

      ],
    }
  },
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;


  }
}

.font-style2 {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-weight: normal;
  font-size: 2.3rem;
}

</style>